import { useEffect, useRef } from "react";
export var usePrevious = function usePrevious(value) {
  var ref = useRef();
  return useEffect(function () {
    ref.current = value;
  }, [value]), ref.current;
};